import Hero from '../components/sections/Hero';
import Services from '../components/sections/Services';
import Gallery from '../components/sections/Gallery';

export default function Home() {
  return (
    <div>
      <Hero />
      <Services />
      <Gallery />
    </div>
  );
}
